export * from "./engine.rawTexture.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import engine.rawTexture.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./engine.rawTexture.pure";
import { RegisterEnginesWebGPUExtensionsEngineRawTexture } from "./engine.rawTexture.pure";
RegisterEnginesWebGPUExtensionsEngineRawTexture();
//# sourceMappingURL=engine.rawTexture.js.map